module.exports = __webpack_public_path__ + "img/rightcalf-ecto-mesomorph-female.39fd7cd1.svg";